import { FormattedMessage } from "react-intl";

// export const BASE_URL = "http://192.168.0.109:8000/";
// export const BASE_URL = "http://192.168.0.110:8000/";
// export const BASE_URL = "https://appbackend.idealignlabs.com/";
export const BASE_URL = "https://backend.terapre.com/";
// export const BASE_URL = "http://192.168.0.107:8000/";
// export const BASE_URL = "http://127.0.0.1:8000/";
// export const BASE_URL = "https://f0b3-154-208-62-131.ngrok-free.app/";
export const DATE_FORMAT_SERVER = "yyyy-MM-dd";
export const DATE_FORMAT_DISPLAY = "dd/MM/yyyy";
export const ACCESS_TOKEN = "idealign_access";
export const PROMOTION_TOKEN = "pro_id_app";

export const POPUP_SMALL = "small";
export const POPUP_MEDIUM = "medium";
export const POPUP_LARGE = "large";

export const CUSTOM_TYPE = "custom-link"
export const SAVE_CONTACT = "save-contact";



export const SAVE_CONTACT_INITIAL_DATA = {
    name: "Save Contact",
    value: "",
    type: SAVE_CONTACT,
    icon_url: "https://s3.eu-central-1.amazonaws.com/pro-id/media/icons/telefon.png",
    platform: "save-contact",
    code: "save-contact",
    output_field: "link"
}

export const FIELD_TEXT = "text";
export const FIELD_NUMBER = "number";
export const FIELD_LINK = "link";
export const FIELD_EMAIL = "email";
export const NUMBER_LINK = "number_link";


export const LISTING_LIMIT = 10;

export const initialPopupState = {
    component: null,
    visible: false,
    size: "small",
    heading: "",
    contained: false,
    hideDefaultClose: false,
    second_component: false
}


//social and card type

export const FACEBOOK = {
    code: "facebook",
    url: "https://www.facebook.com/"
};
export const INSTAGRAM = {
    code: "instagram",
    url: "https://www.instagram.com/"
};
export const SNAPCHAT = {
    code: "snapchat",
    url: "https://www.snapchat.com/add/"
};
export const TWITTER = {
    code: "twitter",
    url: "https://www.twitter.com/"
};

export const SOCIAL_URLS = [
    FACEBOOK,
    INSTAGRAM,
    SNAPCHAT,
    TWITTER
]

export const MAX_CHARS_BIO = 100;
export const SUPPORTED_IMAGES = ["image/png", "image/jpeg"]

export const SUPER_ADMIN_ROLE = "super-admin"
export const DOCTOR_ROLE = "doctor"
export const SUB_DOCTOR_ROLE = "sub-doctor"
export const RESEARCHER_ROLE = "researcher"

export const PAGINATION_OPTIONS = {
    rowsPerPageText: <FormattedMessage id="rows.page" defaultMessage="Rows per page" />,
    rangeSeparatorText: '-',
    selectAllRowsItem: true,
    selectAllRowsItemText: <FormattedMessage id="select.all" defaultMessage={"Select All"} />,
};

export const SPAIN_PROVINCES = [
    {
        value: "Álava",
        label: "Álava",
    },
    {
        value: "Albacete",
        label: "Albacete",
    },
    {
        value: "Alicante",
        label: "Alicante",
    },
    {
        value: "Almería",
        label: "Almería",
    },
    {
        value: "Asturias",
        label: "Asturias",
    },
    {
        value: "Ávila",
        label: "Ávila",
    },
    {
        value: "Badajoz",
        label: "Badajoz",
    },
    {
        value: "Islas Baleares",
        label: "Islas Baleares",
    },
    {
        value: "Barcelona",
        label: "Barcelona",
    },
    {
        value: "Burgos",
        label: "Burgos",
    },
    {
        value: "Cáceres",
        label: "Cáceres",
    },
    {
        value: "Cádiz",
        label: "Cádiz",
    },
    {
        value: "Cantabria",
        label: "Cantabria",
    },
    {
        value: "Castellón",
        label: "Castellón",
    },
    {
        value: "Ciudad Real",
        label: "Ciudad Real",
    },
    {
        value: "Córdoba",
        label: "Córdoba",
    },
    {
        value: "La Coruña",
        label: "La Coruña",
    },
    {
        value: "Cuenca",
        label: "Cuenca",
    },
    {
        value: "Gerona",
        label: "Gerona",
    },
    {
        value: "Granada",
        label: "Granada",
    },
    {
        value: "Guadalajara",
        label: "Guadalajara",
    },
    {
        value: "Guipúzcoa",
        label: "Guipúzcoa",
    },
    {
        value: "Huelva",
        label: "Huelva",
    },
    {
        value: "Huesca",
        label: "Huesca",
    },
    {
        value: "Jaén",
        label: "Jaén",
    },
    {
        value: "León",
        label: "León",
    },
    {
        value: "Lérida",
        label: "Lérida",
    },
    {
        value: "La Rioja",
        label: "La Rioja",
    },
    {
        value: "Lugo",
        label: "Lugo",
    },
    {
        value: "Madrid",
        label: "Madrid",
    },
    {
        value: "Málaga",
        label: "Málaga",
    },
    {
        value: "Murcia",
        label: "Murcia",
    },
    {
        value: "Navarra",
        label: "Navarra",
    },
    {
        value: "Orense",
        label: "Orense",
    },
    {
        value: "Palencia",
        label: "Palencia",
    },
    {
        value: "Las Palmas",
        label: "Las Palmas",
    },
    {
        value: "Pontevedra",
        label: "Pontevedra",
    },
    {
        value: "Salamanca",
        label: "Salamanca",
    },
    {
        value: "Santa Cruz de Tenerife",
        label: "Santa Cruz de Tenerife",
    },
    {
        value: "Segovia",
        label: "Segovia",
    },
    {
        value: "Sevilla",
        label: "Sevilla",
    },
    {
        value: "Soria",
        label: "Soria",
    },
    {
        value: "Tarragona",
        label: "Tarragona",
    },
    {
        value: "Teruel",
        label: "Teruel",
    },
    {
        value: "Toledo",
        label: "Toledo",
    },
    {
        value: "Valencia",
        label: "Valencia",
    },
    {
        value: "Valladolid",
        label: "Valladolid",
    },
    {
        value: "Vizcaya",
        label: "Vizcaya",
    },
    {
        value: "Zamora",
        label: "Zamora",
    },
    {
        value: "Zaragoza",
        label: "Zaragoza",
    },
    {
        value: "Ceuta",
        label: "Ceuta",
    },
    {
        value: "Ceuta",
        label: "Ceuta",
    },
    {
        value: "Melilla",
        label: "Melilla",
    },

]

export const SPAIN_COMMUNITIES = [
    {
        value: "Andalucía",
        label: "Andalucía",
    },
    {
        value: "Aragón",
        label: "Aragón",
    },
    {
        value: "Principado de Asturias",
        label: "Principado de Asturias",
    },
    {
        value: "Islas Baleares",
        label: "Islas Baleares",
    },
    {
        value: "Canarias",
        label: "Canarias",
    },
    {
        value: "Cantabria",
        label: "Cantabria",
    },
    {
        value: "Castilla y León",
        label: "Castilla y León",
    },
    {
        value: "Castilla-La Mancha",
        label: "Castilla-La Mancha",
    },
    {
        value: "Cataluña",
        label: "Cataluña",
    },
    {
        value: "Comunidad de Madrid",
        label: "Comunidad de Madrid",
    },
    {
        value: "Comunidad Valenciana",
        label: "Comunidad Valenciana",
    },
    {
        value: "Región de Murcia",
        label: "Región de Murcia",
    },
    {
        value: "Comunidad Foral de Navarra",
        label: "Comunidad Foral de Navarra",
    },
    {
        value: "País Vasco",
        label: "País Vasco",
    },
    {
        value: "La Rioja",
        label: "La Rioja",
    },
    {
        value: "Ciudad Autónoma de Ceuta",
        label: "Ciudad Autónoma de Ceuta",
    },
    {
        value: "Ciudad Autónoma de Melilla",
        label: "Ciudad Autónoma de Melilla",
    },
]

export const WIRE_TRANSFER = {
    value: "wire-transfer",
    label: <FormattedMessage id="wire_transfer" defaultMessage="Wire Transfer" />
}
export const DEBIT_CREDIT_TRANSFER = {
    value: "debit-credit",
    label: <FormattedMessage id="debit_credit_card" defaultMessage={"Debit/Credit Card"} />
}

export const PAYMENT_TYPE = [
    WIRE_TRANSFER,
    DEBIT_CREDIT_TRANSFER
]

export const DAYS_OF_WEEK = [
    {
        value: "monday",
        label: <FormattedMessage id="mday" defaultMessage="Monday" />,
    },
    {
        value: "tuesday",
        label: <FormattedMessage id="tday" defaultMessage="Tuesday" />,
    },
    {
        value: "wednesday",
        label: <FormattedMessage id="wday" defaultMessage="Wednesday" />,
    },
    {
        value: "thursday",
        label: <FormattedMessage id="thrday" defaultMessage="Thursday" />,
    },
    {
        value: "friday",
        label: <FormattedMessage id="frday" defaultMessage="Friday" />,
    },
    {
        value: "saturday",
        label: <FormattedMessage id="saday" defaultMessage="Satuday" />,
    },
    {
        value: "sunday",
        label: <FormattedMessage id="sday" defaultMessage="Sunday" />,
    },
]

export const ACTIVE_CASES = {
    value: "active-cases",
    label: <FormattedMessage id="a.cses" defaultMessage="Active Cases" />
}
export const PAST_CASES = {
    value: "past-cases",
    label: <FormattedMessage id="p.cses" defaultMessage="Past Cases" />
}

export const ARCHIVED = {
    value: "archived",
    label: <FormattedMessage id="archived" defaultMessage="Archived" />
}

export const APPROVED = {
    value: "approved",
    label: <FormattedMessage id="aprvd" defaultMessage="Approved" />
}
export const NOT_APPROVED = {
    value: "not-approved",
    label: <FormattedMessage id="n.aprvd" defaultMessage="Not Approved" />
}
export const PENDING = {
    value: "pending",
    label: <FormattedMessage id="pending" defaultMessage="Pending" />
}
export const ACTIVE = {
    value: "active",
    label: <FormattedMessage id="acitve" defaultMessage="Active" />
}
export const CLOSED = {
    value: "closed",
    label: <FormattedMessage id="clsed" defaultMessage="Closed" />
}

export const STATUS_ARR = [
    APPROVED,
    NOT_APPROVED,
    PENDING,
    CLOSED
]
export const PATIENT_STATUS_ARR = [
    APPROVED,
    NOT_APPROVED,
    PENDING,
    CLOSED,
    ARCHIVED
]

export const MALE = {
    value: "male",
    label: <FormattedMessage id="mle" defaultMessage="Male" />
}
export const FEMALE = {
    value: "female",
    label: <FormattedMessage id="fmle" defaultMessage="Female" />
}
export const OTHER = {
    value: "other",
    label: <FormattedMessage id="other" defaultMessage="Other" />
}

export const GENDER = [
    MALE,
    FEMALE,
    OTHER
]
export const INVOICE_STATUS = [
    {
        value: "paid",
        label: <FormattedMessage id="paid" defaultMessage="Paid" />
    },
    {
        value: "unpaid",
        label: <FormattedMessage id="unpaid" defaultMessage="Unpaid" />
    },
]

export const TYPE_OF_TREATMENT = [
    // {
    //     value: "without-worries",
    //     label: <FormattedMessage id="wi.wr" defaultMessage="Without Worries"/>
    // },
    // {
    //     value: "to-your-measure",
    //     label: <FormattedMessage id="t.y.m" defaultMessage="To your measure"/>
    // },
    // {
    //     value: "pre-prosthetic-treatment",
    //     label: <FormattedMessage id="pr.p.t" defaultMessage="Pre-Prosthetic Treatment"/> 
    // },
    // {
    //     value: "retainers",
    //     label: <FormattedMessage id="retaners" defaultMessage="Retainers"/> 
    // },
    {
        value: "traditional-aligner-method",
        label: <FormattedMessage id="traditional-aligner-method" defaultMessage={"Traditional Aligner Method"} />
    },
    {
        value: "terapre-aligner-method",
        label: <FormattedMessage id="terapre-aligner-method" defaultMessage={"Terapre Aligner Method"} />
    },
    {
        value: "refinement",
        label: <FormattedMessage id="refinement" defaultMessage={"Refinement"} />
    },
    {
        value: "retainers",
        label: <FormattedMessage id="retainers" defaultMessage={"Retainers"} />
    },
]
export const ARCH_TO_TREAT = [
    {
        value: "botch-arches",
        label: <FormattedMessage id="b.arche" defaultMessage="Both arches" />
    },
    {
        value: "upper-arch",
        label: <FormattedMessage id="u.arche" defaultMessage="Upper Arch" />
    },
    {
        value: "lower-arch",
        label: <FormattedMessage id="l.arche" defaultMessage="Lower Arch" />
    },
]
export const ALIGNER_TRIM = [
    // {
    //     value: "trim-1-3mm",
    //     label: <FormattedMessage id="t.1.3" defaultMessage="Trim leaving 1-3mm of gum"/> 
    // },
    // {
    //     value: "trim-neck",
    //     label: <FormattedMessage id="t.n.l" defaultMessage="Trim At Neck Level"/> 
    // },
    {
        value: "trim-at-gum-line",
        label: <FormattedMessage id="trim-at-gum-line" defaultMessage={"Trim at the gum line"} />
    },
    {
        value: "trim-leaving-1_3_above_gum",
        label: <FormattedMessage id="trim-leaving-1_3_above_gum" defaultMessage={"Trim leaving 1-3 mm above the gum line"} />
    },
]
export const RETAINERS_TYPE = [
    {
        value: "fixed",
        label: <FormattedMessage id="fxed" defaultMessage="Fixed" />
    },
    {
        value: "removable",
        label: <FormattedMessage id="rmvb" defaultMessage="Removable" />
    },
    {
        value: "both",
        label: <FormattedMessage id="both" defaultMessage="Both" />
    },
]

export const ENGLISH_LANGUAGE = {
    value: "en",
    label: "English",
    ltr: true,
}
export const SPANISH_LANGUAGE = {
    value: "es",
    label: "Espanol",
    ltr: true,
}
export const FRENCH_LANGUAGE = {
    value: "fr",
    label: "French",
    ltr: true,
}

export const LANG_ARR = [
    ENGLISH_LANGUAGE,
    SPANISH_LANGUAGE,
    FRENCH_LANGUAGE
]

export const OPTION_ALIGNERS = {
    value: "clear-aligners",
    label: <FormattedMessage id="clear_aligners" defaultMessage="Clear Aligners" />
}

export const DELIVERED = {
    value: "delivered",
    label: <FormattedMessage id="delivered" defaultMessage={"Delivered"} />
};

export const DELIVERY_STATUSES = [
    DELIVERED,
    PENDING
]

export const OPTIONS_FOR_DELIVERIES = [
    OPTION_ALIGNERS
]

export const STL_IN_PROGRESS = {
    value: "in_progress",
    label: <FormattedMessage id="in_progress" defaultMessage={"In Progress"} />
}
export const STL_NOT_STARTED = {
    value: "not_started",
    label: <FormattedMessage id="not_started" defaultMessage={"Not Started"} />
}
export const STL_COMPLETED = {
    value: "completed",
    label: <FormattedMessage id="completed" defaultMessage={"Completed"} />
}

export const STL_STATUS = [
    STL_IN_PROGRESS,
    STL_NOT_STARTED,
    STL_COMPLETED
]

export const INDEX_STATUS_PROCESSING = {
    value: "processing",
    label: <FormattedMessage id="processing" defaultMessage={"Processing"} />,
    bg: "#fef3c7",
    text: "#f59e0b"
}
export const INDEX_STATUS_READY = {
    value: "ready",
    label: <FormattedMessage id="ready" defaultMessage={"Ready"} />,
    bg: "#dcfce7",
    text: "#22c55e"
}
export const INDEX_STATUS_FAILED = {
    value: "failed",
    label: <FormattedMessage id="failed" defaultMessage={"Failed"} />,
    bg: "#fee2e2",
    text: "#ef4444"
}

export const INDEX_STATUSES = [
    INDEX_STATUS_PROCESSING,
    INDEX_STATUS_FAILED,
    INDEX_STATUS_READY,
]

export const DOCUMENT_STATUS_PENDING = {
    value: "pending",
    label: <FormattedMessage id="pending" defaultMessage={"Pending"} />,
    bg: "#dbeafe",
    text: "#3b82f6"
}
export const DOCUMENT_STATUS_PROCESSING = {
    value: "processing",
    label: <FormattedMessage id="processing" defaultMessage={"Processing"} />,
    bg: "#fef3c7",
    text: "#f59e0b"
}

export const DOCUMENT_STATUS_FAILED = {
    value: "failed",
    label: <FormattedMessage id="failed" defaultMessage={"Failed"} />,
    bg: "#fee2e2",
    text: "#ef4444"
}

export const DOCUMENT_STATUS_READY = {
    value: "done",
    label: <FormattedMessage id="done" defaultMessage={"Done"} />,
    bg: "#dcfce7",
    text: "#22c55e"
}

export const DOCUMENT_STATUSES = [
    DOCUMENT_STATUS_PENDING,
    DOCUMENT_STATUS_PROCESSING,
    DOCUMENT_STATUS_FAILED,
    DOCUMENT_STATUS_READY
]

export const TEETH_MISSING = {
    value: "missing",
    label: <FormattedMessage id="missing" defaultMessage={"Missing"} />,
    color: "#ec4899"
}
export const TEETH_IMPLANT = {
    value: "implant",
    label: <FormattedMessage id="implant" defaultMessage={"Implant"} />,
    color: "#84cc16"
}
export const TEETH_VENEER = {
    value: "veneer",
    label: <FormattedMessage id="veneer" defaultMessage={"Veneer"} />,
    color: "#f59e0b"
}
export const TEETH_BRIDGE = {
    value: "bridge",
    label: <FormattedMessage id="bridge" defaultMessage={"Bridge"} />,
    color: "#06b6d4"
}

export const TEETH_TYPES = [
    TEETH_MISSING,
    TEETH_IMPLANT,
    TEETH_VENEER,
    TEETH_BRIDGE
]

export const teeth_array_top = Array.from({ length: 16 }, (_, index) => {
    return {
        value: index + 1,
        image: `/images/teeth/${index + 1}.png`
    }
})

export const teeth_array_bottom = Array.from({ length: 16 }, (_, index) => {
    return {
        value: index + 17,
        image: `/images/teeth/${index + 17}.png`
    }
}).reverse()

export const CHECK_STATUS_PENDING = {
    value: "pending",
    label: <FormattedMessage id="pending" defaultMessage={"Pending"} />
}
export const CHECK_STATUS_COMPLETED = {
    value: "completed",
    label: <FormattedMessage id="completed" defaultMessage={"Compelted"} />
}

export const CHECK_STATUSES = [
    CHECK_STATUS_PENDING,
    CHECK_STATUS_COMPLETED
]

export const CHECK_DECISION_CONTINUE = {
    value: "continue",
    label: <FormattedMessage id="continue_with_aligners" defaultMessage={"Continue With Aligners"} />
}

export const CHECK_DECISION_NEW_CASE = {
    value: "new_case",
    label: <FormattedMessage id="new_case" defaultMessage={"New Case"} />
}